import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
    selector: 'fifty-lakhs-error-popup',
    templateUrl: './fifty-lakhs-error-popup.component.html',
    styleUrls: ['./fifty-lakhs-error-popup.component.scss']
})
export class FiftyLakhsErrorPopupComponent implements OnInit {
    private matDialogRef: MatDialogRef<FiftyLakhsErrorPopupComponent>;
    private readonly matDialog: MatDialog;
    public data;
    constructor(
        matDialog: MatDialog,
        matDialogRef: MatDialogRef<FiftyLakhsErrorPopupComponent>,
        @Inject(MAT_DIALOG_DATA) data: {
            investmentAmount: number,
            investmentLimit: number,
        }
    ) {
        this.matDialog = matDialog;
        this.matDialogRef = matDialogRef;
        this.data = data;
    }
    ngOnInit(): void {
        
    }

    onBackButtonClicked() {
        this.matDialogRef.close();
    }
}